import styled from "styled-components";

export const StyledItemPreviewModal = styled.div`
    width: 100%;

    .img {
        width: 100%;
        max-height: 273px;
        border-radius: 20px;
        border: 1px dashed rgba(205, 205, 205, 1);
        height: auto;
        object-fit: contain;
        margin-bottom: 20px;
    }

    .title-wrap {
        display: flex;
        justify-content: space-between;
        align-items: start;
        flex-direction: column-reverse;
        gap: 16px;
        margin-bottom: 8px;
        @media (min-width: 576px) {
            flex-direction: row;
            align-items: center;
        }
        .title {
            color: rgba(49, 49, 49, 1);
            font-size: 28px;
            line-height: 32px;
            font-weight: 500;
        }
        .status-wrap {
            background: rgba(40, 154, 0, 0.1);
            padding: 8px 18px;
            border-radius: 60px;
            display: flex;
            align-items: center;
            gap: 4px;
            .success-dot {
                width: 12px;
                height: 12px;
                background-color: rgba(40, 154, 0, 1);
                border-radius: 50%;
            }
            .status {
                color: rgba(40, 154, 0, 1);
                font-size: 16px;
                line-height: 20px;
                font-weight: 400;
            }
        }
    }

    .desc {
        display: block;
        width: 100%;
        max-width: 276px;
        color: rgba(49, 49, 49, 1);
        font-size: 16px;
        line-height: 20px;
        font-weight: 400;
        margin-bottom: 20px;
    }

    .row {
        display: flex;
        align-items: center;
        gap: 15px;
        margin-bottom: 20px;
        .tag {
            color: rgba(49, 49, 49, 1);
            background-color: rgba(233, 233, 233, 1);
            padding: 5px 7px;
            border-radius: 5px;
            font-size: 16px;
            line-height: 20px;
            font-weight: 300;
        }
        .calories {
            color: rgba(49, 49, 49, 1);
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
        }
        .price {
            color: rgba(49, 49, 49, 1);
            font-size: 24px;
            line-height: 28px;
            font-weight: 500;
        }
        .discount-price {
            color: rgba(143, 143, 143, 1);
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
        }
    }

    .separator {
        border-bottom: 1px solid rgba(236, 236, 236, 1);
        margin-bottom: 30px;
    }

    .btn-holder {
        @media (min-width: 576px) {
            display: flex;
            gap: 14px;
        }
        .btn {
            width: 100%;
            margin-bottom: 10px;
        }
    }
`;
